<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-1">
          <button
            class="btn btn-rounded btn-fill"
            :class="[
              { ' btn-success': !localReadonly },
              { ' btn-warning': localReadonly },
            ]"
            style="padding-left: 10px; padding-right: 10px"
            v-on:click="unlock()"
          >
            <i
              :class="[
                { 'ti-unlock': !localReadonly },
                { 'ti-lock': localReadonly },
              ]"
            ></i>
          </button>
        </div>

        <div class="col-md-12">
          <auction-form :data="data" :readonly="localReadonly" :edit="true" />
        </div>

        <div class="col-md-12 text-right">
          <btn-rounded label="SALVAR" event="save" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <component-table
                eventName="selectUser"
                :readonly="localReadonly"
                :title="tableAuctionOffer.title"
                :sub-title="tableAuctionOffer.subTitle"
                :data="list || data.AuctionOffers"
                :control="tableAuctionOffer.control"
                :columns="tableAuctionOffer.columns"
                :headers="tableAuctionOffer.headers"
              />
            </div>
          </div>
        </div>
        <v-dialog />
      </div>
    </div>
  </div>
</template>
<script>
import AuctionForm from "src/components/UIComponents/Forms/AuctionForm.vue";
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import formConfirmButton from "src/components/UIComponents/Inputs/formConfirmButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Notifications from "vue-notification";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import moment from "moment";

Vue.use(Notifications);
Vue.use(Viewer);

const headersAuctionOffer = [
  "Código",
  "Nome",
  "Telefone",
  "E-mail",
  "Oferta",
  "Status",
  "Data do lance",
];
const tableColumnsAuctionOffer = [
  "orderNumber",
  "User.name",
  // {
  //   columnName: "User.name",
  //   logic: function(data) {
  //     if (!data) return "";

  //     const className = "text-primary";
  //     const prefix = `<span class="${className}" style="cursor: pointer; text-decoration: underline;">${data}</span>`;

  //     return prefix;
  //   },
  // },
  {
    columnName: "User.formattedPhone",
    logic: function(data) {
      if (!data) return "";

      const className = "text-primary";
      const prefix = `<span class="${className}" style="cursor: pointer; text-decoration: underline;">${data}</span>`;

      return prefix;
    },
    onclick: function(data) {
      this.$modal.show("dialog", {
        title: "Redirecionamento",
        text: "Você será redirecionado para o WhatsApp. Deseja continuar?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              let phone = "+55" + data;
              if (phone) {
                window.open(
                  `https://wa.me/${phone.replace(/\D/g, "")}`,
                  "_blank"
                );
              } else {
                this.$notify({
                  group: "foo",
                  title: "Erro",
                  text: "Número de telefone não disponível.",
                  type: "error",
                });
              }
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Cancelar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },
  },
  {
    columnName: "User.email",
    logic: function(data) {
      if (!data) return "";

      const className = "text-primary";
      const prefix = `<span class="${className}" style="cursor: pointer; text-decoration: underline;">${data}</span>`;

      return prefix;
    },
    onclick: function(data) {
      this.$modal.show("dialog", {
        title: "Redirecionamento",
        text: "Você será redirecionado para o Email. Deseja continuar?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              if (data) {
                window.location.href = `mailto:${data}`;
              } else {
                this.$notify({
                  group: "foo",
                  title: "Erro",
                  text: "E-mail não disponível.",
                  type: "error",
                });
              }
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Cancelar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },
  },
  "formattedOffer",
  {
    columnName: "accepted",
    logic: function(data) {
      let className = "text-danger";
      let val = "Não Aceito";
      if (data) {
        className = "text-success";
        val = "Aceito";
      }
      let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

      return `${prefix} ${val}`;
    },
  },
  "formattedCreatedAt",
];

export default {
  components: {
    AuctionForm,
    formConfirmButton,
    ComponentTable,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    ...mapState({}),
  },
  watch: {
    $route: "initData",
  },
  methods: {
    ...mapActions(["updateAuction", "getAuction"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),

    // filterActionOffersList(){
    //   var offers = []
    //     this.auctionList.forEach(auction => {
    //       if (auction.AuctionOffers) {
    //         offers = auction.AuctionOffers
    //       }
    //     })
    //     return offers;
    //   },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      var tempo = this.data.deadline.toString().split(" ");
      this.data.date = moment
        .utc(tempo[0])
        .utcOffset(0)
        .format("YYYY-DD-MM");
      this.data.time = tempo[1];

      this.verifyID();
    },

    verifyID() {
      if (this.data == undefined) {
        this.$router.push({
          name: "Ofertas - Lista",
        });
      }
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },
  },

  data() {
    return {
      localReadonly: false,
      data: null,
      readonly: true,
      tableAuctionOffer: {
        title: "Lances recentes",
        subTitle: "Lista todos os lances da Oferta",
        headers: [...headersAuctionOffer],
        columns: [...tableColumnsAuctionOffer],
      },
    };
  },

  created() {
    this.data = this.$route.params.id;

    this.data.AuctionOffers.sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });

    this.cleanFilter();
    this.localReadonly = this.readonly;

    this.$on("save", () => {
      this.updateAuction(this.data)
        .then((res) => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success",
          });
          this.localReadonly = true;
        })
        .catch((res) => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error",
          });
        });
    });

    this.$on("selectUser", (item) => {
      this.$modal.show("dialog", {
        title: "Direcionamento",
        text: "Deseja realmente entrar na alteração desse usuário?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              this.$router.push({
                name: "Usuários - Editar",
                params: { id: item.User },
              });

              this.$modal.hide("dialog");
            },
          },
          {
            title: "Não", // Button title
            handler: () => {
              this.$modal.hide("dialog");
            }, // Button click handler
          },
        ],
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.card-image {
  border: solid 1px white;
  padding: 15px;
  background-color: #f0f0f0;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotateimg270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}

.images {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Auction/AuctionEdit.vue